import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUsers(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const includeStageCounts =
      payload?.includeStageCounts === false ||
      payload?.includeStageCounts === 0 ||
      payload?.includeStageCounts === "0"
        ? "0"
        : payload?.metaOnly
          ? "1"
          : "0";
    const metaOnly =
      payload?.metaOnly === true ||
      payload?.metaOnly === 1 ||
      payload?.metaOnly === "1"
        ? "1"
        : "0";
    const idsOnly =
      payload?.idsOnly === true ||
      payload?.idsOnly === 1 ||
      payload?.idsOnly === "1"
        ? "1"
        : "0";
    const params = new URLSearchParams({
      start_date: payload.startDate || "",
      end_date: payload.endDate || "",
      id: payload.userId || "",
      page: String(payload.pageNo || 0),
      limit: String(payload.pageSize || 25),
      teamId: payload.team_id || "",
      formId: payload.formId || "",
      stage: payload.stage || "",
      source: payload.source || "",
      search: payload.search || "",
      exclude_source: payload.exclude_source || "",
      assignment: payload.assignment || "",
      uploadLeadId: payload.uploadLeadId || "",
      includeStageCounts,
      metaOnly,
      idsOnly,
    });
    if (payload.memberId) {
      params.set("memberId", String(payload.memberId));
    }
    if (payload.fresh === "1" || payload.fresh === 1 || payload.fresh === true) {
      params.set("fresh", "1");
    }
    const orgId = String(payload?.organizationId || "").trim();
    if (orgId && orgId !== "all" && orgId !== "*") {
      params.set("organizationId", orgId);
    }
    const response = await makeCall(
      `${urls.LEADDATA}?${params.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

/** All matching lead ids for current filters (all pages). */
export async function getAllMatchingLeadIds(payload: any) {
  return getAllUsers({
    ...payload,
    pageNo: 0,
    pageSize: 20000,
    includeStageCounts: 0,
    metaOnly: 0,
    idsOnly: 1,
  });
}

export async function getLeadById(id: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETLEADBYID}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getDateWiseLead(
  userId: string,
  from: string,
  to: string,
  pageNo: any,
  pageSize: any
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.LEADDATA +
        `?start_date=${from}&end_date=${to}&id=${userId}&page=${pageNo}&limit=${pageSize}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETALLLEADS}?slim=1&limit=2000`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getFormByID(id:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETALLLEADS}/${id}`, callParams);

    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamData(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeamMembersData(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(`${urls.GETMEMBERSDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTeam() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllDepartmentsForFilter() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLDEPARTMENT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

/** Teams for one or more departments (client-filters full team tree). */
export async function getTeamsForFilter(departmentIds: string | string[]) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETTEAMDROP}`, callParams);
    const deptSet = new Set(
      (Array.isArray(departmentIds) ? departmentIds : [departmentIds])
        .map((id) => String(id || "").trim())
        .filter(Boolean)
    );
    const allTeams = Array.isArray(response?.data) ? response.data : [];
    if (!deptSet.size) return { ...response, data: allTeams };
    const filtered = allTeams.filter((t: any) =>
      deptSet.has(String(t?.departmentId || ""))
    );
    return { ...response, data: filtered };
  } catch (error) {
    throw error;
  }
}

export async function getMembersForFilter(teamIds: string[]) {
  try {
    const ids = (teamIds || []).map(String).filter(Boolean);
    if (!ids.length) return { data: [], success: 1 };
    const callParams = await getCallParams("POST", { team_id: ids });
    const response = await makeCall(urls.GETMEMBERSDROP, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllStage() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllSource() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLSOURSE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminder(id: any) {
  
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETREMINDER}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getReminderData() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETREMINDERALL}?slim=1`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeStatusApi(status: any, userId: any) {
  const payload = {
    id: userId,
    status: status == 0 ? 1 : 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.USERUPDATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteReminder(userId: any) {
  const payload = {
    id: userId,
    status: 0,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.DELETEREMARK, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStage(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATESTAGE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function changeAt(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEAI, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveReminder(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATEREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateReminder(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATELEADREMINDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function assignToMembers(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.ASSIGNTOMEMBERS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllReminder(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.UPDATEREMINDER + `/${id?.id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getAllLeadHistory(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETLEADHISTORY + id, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getDownloadLeads() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.DOWNLOADSLEADS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
/** Building the workbook server-side takes far longer than a normal list call. */
const EXPORT_TIMEOUT_MS = 180000;

export async function getDownloadLeadsExcle(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const params = new URLSearchParams();
    params.set("start_date", toExportDate(payload?.startDate));
    params.set("end_date", toExportDate(payload?.endDate));
    params.set("formId", payload?.formId || "");
    if (payload?.organizationId) {
      params.set("organizationId", String(payload.organizationId));
    }
    if (payload?.search) params.set("search", String(payload.search));
    if (payload?.stage) params.set("stage", String(payload.stage));
    if (payload?.source) params.set("source", String(payload.source));
    if (payload?.assignment) params.set("assignment", String(payload.assignment));
    if (payload?.uploadLeadId) {
      params.set("uploadLeadId", String(payload.uploadLeadId));
    }
    if (payload?.memberId) params.set("memberId", String(payload.memberId));
    if (payload?.team_id) params.set("teamId", String(payload.team_id));
    if (payload?.fresh === "1" || payload?.fresh === 1 || payload?.fresh === true) {
      params.set("fresh", "1");
    }

    const response = await makeCall(
      `${urls.DOENLOADSLEADSEXCEL}?${params.toString()}`,
      callParams,
      EXPORT_TIMEOUT_MS
    );

    return response;
  } catch (error) {
    throw error;
  }
}

/** Backend date filter expects DD-MM-YYYY; the picker hands us a Date/ISO value. */
function toExportDate(value: any): string {
  if (!value) return "";
  if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value.trim())) {
    return value.trim();
  }
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}-${d.getFullYear()}`;
}